module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapnum"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_vm._v("Admit It, Your Life Doesn’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Feel")]), _vm._v(" as Good as It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Looks")])]), _vm._v(" "), _c('div', {
    staticClass: "quotec"
  }, [_c('p', {
    staticClass: "quotec"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“I think you actually have to have all your dreams come true, to realize they’re the wrong dreams.”")])]), _vm._v(" "), _c('p', {
    staticClass: "quotec1"
  }, [_vm._v("MATTHEW PERRY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY ON IN MY COACHING PRACTICE")]), _vm._v(", a client confessed to me one day his reluctance to attend his Ivy League business school reunion. An old chum had told him, apparently, that “if you don’t make at least $2 million a year, you shouldn’t even bother coming to this thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("First, let’s face it, that’s a weird thing to say to anyone, let alone someone you supposedly consider a friend. Second, objectively, my client was a superstar with enviable achievements that made him stand out well beyond any arbitrary financial milestone. He was successful, sure. But he was also funny, engaging, kind, hard-working, generous, AND in a stable, loving relationship. He had it all! So when he told me that he was considering not going to the reunion based on this comment, I was shocked. Right there, on the tip of my tongue was, “C’mon, man. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Really")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I held my tongue. I was in the first year of my practice and, as green as I was, I empathized with his feelings—irrational though they seemed. I’d experienced these same feelings and these fears, as had many of my other upper-echelon clients. As overachievers, we’re so susceptible to competition on all levels, to the “keeping up with the Joneses’” mentality, both in our professional and personal lives. And since you’ve picked up this book, chances are you empathize as well.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Overachievers often have lives that don’t feel as good as they look, and they cope with this incongruity via a wide gamut of anxious thought patterns and fears. They argue for and develop reasons to justify the pace at which they are advancing socially, professionally, and financially, very rarely stopping to question whether the mountain they are climbing is even the right mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some variation of this “keep calm and carry on” attitude has likely been a part of your rise, and it has been a part of your friends’ success, too. One such friend to us all was the actor Matthew Perry, who I adored as Chandler Bing. In the book he released the year before his death, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Friends, Lovers, and the Big Terrible Thing")]), _vm._v(", Perry—a bona fide superstar—detailed his struggles with drugs and admitted to standing on shaky interior ground. He had everything at his feet, including demons and addictions. In his book, Perry describes a scene similar to what my Ivy-League–reunion distraught client was experiencing. It’s a hilarious, mistaken-identity story surrounding a meetup with the movie director M. Night Shyamalan—or at least a person who he thought was M. Night Shyamalan. The story involves him being gobsmacked by the “legendary director’s” interest in little old him. You should read the story (and the whole book, in fact), but in the meantime, I bring up Perry and this story to say: If you are worrying about whether you measure up, whether you will ever make it to the point where you no longer feel the anxiety and pressure that comes with success, you won’t. At least not through more overachieving. If the emptiness of success and the anxiety found their way to Matthew Perry’s door, they can come to anyone’s.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perry exemplifies, or exemplified, what I have found to be common: There is a sadness and insecurity lying in the hearts of many ambitious people; an undercurrent of anxiety, panic, and dissatisfaction that rests beneath the carefully crafted facades. These feelings usually emerge upon the unsettling recognition that all they’ve attained may glisten but are not gold. Things may look shiny and safe, but in truth, they are anything but.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Truman Capote’s “swans” are a testament that this truth has transcended and will continue to transcend generations. “Swans” was the moniker he gave his gaggle of gorgeous friends, like Lee Radziwill, Babe Paley, and Slim Keith—the well-heeled ladies of the Upper East Side, women of extraordinary wealth and status whom he famously betrayed in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Esquire")]), _vm._v(" article, “La Cote Basque.” The moniker was a reference to the hidden effort his elegant friends took to maintain their immaculate facades—a swan gliding upon the water effortlessly but beneath the surface furiously "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("paddling to keep up with the others. Grace on the surface but a constant struggle for their position underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We are all, in a sense, attempting to be swans, desperately swimming and swimming beneath regal, but extremely bulky, feathers. Capote’s subjects, like me before finding the subject of personal development—and my clients prior to coaching—found a semblance of perfection in outward appearances. We adorned ourselves with shiny trinkets that appeared to outsiders as flawless and golden, but once the luster fell off, we recognized they were never golden at all. We realized that instead of attaining what we’d been pursuing—freedom—we ended up in a glittering cage through our heedless pursuit of external success. We’d been gilded by our own ambitions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In my coaching practice, where I deal with high-performers day in and day out, I’ve coined a term for this phenomenon, one I see time and time again: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Overachievement Paradox."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#fn1",
      "id": "rfn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" The paradox is of appearing to have it all and yet being discontent. Once you look like you have it all, you feel a pressure to maintain that look—defeating any semblance of peace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rather than episodic, The Paradox is more like stumbling on a neurosis"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v(" It’s less “in the moment stress or disappointment” and more “constant state of teetering between one-upmanship and paranoia.” It’s a form of cognitive dissonance that convinces the wealthy they’ll run out of money. It drives the brilliant to second guessing their intellect. It tells the exhausted they need to work harder to always be the best, have the best, and look the best. The Paradox also comes at a high price: perpetual self-sacrifice at the altar of achievement, which destroys the quality of your relationships—because very hard-working, obsessive, single-minded overachievers can be"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("…at times, a bit mean to themselves and to everyone else, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This phenomenon doesn’t just cost you a chance to attend your class reunion and catch up with old friends. It’s a form of self-sabotage that can result in much worse: messy debt, ugly divorces, loveless marriages, intimacy issues, infidelity, isolation, paranoia, mistrust, harsh management styles, alcohol abuse, drug or doom-scrolling addictions, workaholism, strained familial and business relationships, loneliness, and physical illness. And the most common form of sabotage of them all? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Aimlessness.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aimlessness is harboring, for long stretches of time, a feeling that life is moving along but that you have not yet found your purpose—that you are somehow stuck even though you are in perpetual motion. Sure, you are living, but you aren’t lit up. You are doing all the right things but missing your potential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Do any of these strike a chord?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If so, here’s what they all have in common: They’ve all appeared as a result of misdirecting our aim. Instead of striving for happiness, we chased surrogates like fancy titles, big houses, or money for money’s sake. Those rewards end up feeling like aimlessness or loneliness because we never cared about them that much to begin with. "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Ambitious people do not focus "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("on")]), _vm._v(" happiness.")]), _vm._v(" We focus on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("surrogates")]), _vm._v(" for happiness. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("After all, why be happy when you can be rich? Or famous? Or powerful?")]), _vm._v(" Given that many overachievers have spent their lives getting high marks, growing businesses, building wealth, winning awards, marrying other overachievers, and socializing with A-list celebrities, it’s no wonder we have missed contentment by turning external stimuli into reality—ending up being as “real” as reality television.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Worse still, behind the veneer of success are burned-out souls suffering from narcissism, fear, anger, and depression"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Notes#fn2",
      "id": "rfn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" as a result of constantly banging up against this superficial reality. This can have devastating effects not only on the health and psyche of the individual but also on spouses, children, business partnerships and organizations, and subordinate employees. Though overachievers are often highly compensated, money isn’t enough to offset the pressures of the corporate shark-eat-shark environment. The resulting pressure leads “externally perfect” executives caught in The Overachievement Paradox to explode in short-tempered anger and fear that stymies forward-thinking decision-making. Thus, ambitious, hard-working overachievers like yourself often experience sleepless nights and feel isolated, believing they have no one in whom to truly confide—allowing depression to settle in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When high-profile figures, such as iconic fashion designer Kate Spade; TV celebrity Anthony Bourdain; nineties icons Stella Tenant, Chris Cornell, and Dolores O’Riordan; or actor Robin Williams, die by suicide, we watch in stunned amazement. How could those with both notoriety and fortune possibly have been so unhappy? There are many Kate Spades among overachievers right now—in our offices, at our conferences, and in our homes.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Are you wondering whether your driven"), _c('span', {
    staticClass: "bold"
  }, [_vm._v(",")]), _vm._v(" high-achieving ways are missing their aim, too? Here is how to self-diagnose. Ask yourself:")]), _vm._v(" "), _c('div', {
    staticClass: "bull"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Do you believe you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("don’t yet")]), _vm._v(" have everything you want?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Does the success of others make you jealous, annoyed, or resentful?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Do you have trouble sleeping?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Do you spend many moments a day in anxiety (replaying conversations, running doomsday scenarios of possible failures, losses, and rejections)?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Do you frequently experience sadness, negative emotions, and mood swings?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Do you feel an unyielding pressure to not only perform but to out-perform your peers (and, if possible, the whole world)?")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Do you feel like you do many things—stay in relationships, maintain participatory status—out of obligation?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you answered yes to any of the above, you are an overachiever and likely face similar neuroses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an anonymous survey conducted with more than 1,000 people earning $250,000+ and holding high degrees of education, 53 percent answered "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("yes")]), _vm._v(" to all of the above. Even in our current economy, a surprising portion of American professionals report feeling unhappy. In the mid-1980s, roughly 61 percent of workers told pollsters they were satisfied with their jobs. Today, that number has declined substantially, hovering around half. The lowest point being in 2010, when only 43 percent of workers were satisfied, according to data collected by the Conference Board, a nonprofit research organization. The rest said they were unhappy or, at best, neutral about how they spent the bulk of their days. Even studies among professionals in medicine and law noted a rise in discontent. As for overachievers, research suggests we may be depressed at more than double the rate of the public. For example, prominent psychiatrist Michael Freedman found that nearly half (49 percent) of entrepreneurs said they experienced mental health issues at some point in their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This discontent comes with an entire Pandora’s box of effects, too, because overachievers are unlikely to deal with malaise or openly share it. A few examples of the most common stances I’ve observed in coaching sessions are:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bull"
  }, [_c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Exhibiting mental arrogance—the state of believing you know everything and that you’ve “got this”")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Having a fear of making mistakes and of perceived failure (of self and others)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Upholding an invulnerable stance/pretense and saving face")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Displaying an impenetrable stance, a lack of vulnerability (ability to admit your own mistakes or imperfections), lack of empathy for self and others")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Being too heavily dependent upon the opinions of others")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Asserting status by people-pleasing; trying to be all things to all people")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Believing success only comes as it relates to power, money, or status")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "bull"
  }, [_vm._v("•")]), _vm._v(" Creating self-imposed limitations based on original/early-stage perceptions of goals/arbitrary success benchmarks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("These issues can be extremely common among high-achieving individuals. They can also be debilitating and interfere with healthy functioning, effective communication, and interpersonal dynamics. All too often, addiction, depression, and anxiety may not be readily apparent to the individual suffering from these challenges or to those people working and living alongside them, which complicates things further. If "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" can relate to any of the above, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("the hardest part will be admitting that you have a problem")]), _vm._v(". But if you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" open to change and commit to doing the work, you will find happiness, satisfaction, and joy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Case in point: My client that was going to skip his reunion? He committed to doing the internal work, the work laid out in this book. The result? He went to his reunion, showed up with no pretenses, mingled with no veneer, and reported back that he had a really good time—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("free of his own gilded cage")]), _vm._v(". That may sound like a small achievement, but it was the day he opened his own cage door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you are up for the rest of this journey, start by admitting that what you’ve got going on is not working and realize what’s off is that you think “you’ve got this” when, in fact, you do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Almost everything you have accepted as your target has been way off. It must be. After all, you are not where you think you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" be. The admission part is up to you. There’s no shame in the game. It would just be a shame if you stayed here.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "img_containerbb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxt"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("PRACTICE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As we begin this journey together, sit down and:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Map out what each facet of your life would look like if you were truly happy. This can include marriage, children, extended family, friendships, professional networks, social media/networking, financial state, travel, physical fitness, self-care/beauty, fashion and style, transportation, entertainment, hobbies, and passions. If you have other areas of your life that you would like to add, do it. You’ll soon see that life fulfillment means—and needs—so much more than what happens on the work front.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "img_containerbb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxt"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("CHAPTER SUMMARY")])]), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1.")]), _vm._v(" Many people aren’t as happy as they look, especially successful entrepreneurs and C-suite execs—or “overachievers.”")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2.")]), _vm._v(" The main source of dissatisfaction: the constant pursuit of success instead of happiness, which is how many, especially overachievers, measure self-worth—with a principal focus on financial status.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3.")]), _vm._v(" If you relate, aiming for a deeper understanding of yourself and what you want can lead to heightened success and a healthier, happier mindset. Trying to solve the malaise you feel by chasing more success (i.e., making more money) is just a bottomless pit that will never end and only begin to feel more futile.")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("4.")]), _vm._v(" This does not mean beating yourself up but merely admitting you may have less than what you truly want out of life. ")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("5.")]), _vm._v(" The realization that you are not happy should not upset you or worry you (even though it might). It is the only thing that will begin to set you free because you will have changed your aim.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e04b710","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter01.vue
// module id = 81
// module chunks = 0